import Vue from 'vue'
export const accountService = {
    sendContactValidationCode,
    validateContactValidationCode,
};

const headersParam = {
    "Accept": "*/*",
    "Content-Type": "application/json",
    "Cache-Control": "no-cache",
    "Pragma": "no-cache",
};

function sendContactValidationCode(sendContactValidationCodeRequest) {
    let url = "/account/sendContactValidationCode";

    return Vue.prototype.$axios.post(url, sendContactValidationCodeRequest, headersParam)
        .then(handleResponse)
        .then((response) => {
            if (response.data.success)
                return response;
        });
}

function validateContactValidationCode(validateContactValidationCodeRequest) {
    let url = "/account/validateContactValidationCode";

    return Vue.prototype.$axios.post(url, validateContactValidationCodeRequest, headersParam)
        .then(handleResponse)
        .then((response) => {
            if (response.data.success)
                return response;
        });
}

function handleResponse(response) {
    if (!response.data || !response.data.success) {

        const error = response.data?.error || response.statusText;
        return Promise.reject(error);
    }

    return response;

}